import {ChangeDetectionStrategy, Component, HostBinding, Input} from "@angular/core";
import {FUIAbstractLabel} from "../abstract-label";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-message-label",
    styleUrls: ["./message-label.component.scss"],
    templateUrl: "./message-label.component.html",
    standalone: false
})
export class FUIMessageLabelComponent extends FUIAbstractLabel {
    @Input() i18nParams: any = {};

    @HostBinding("class.clickable") @Input() clickable: boolean = false;
    @HostBinding("class.underlined") @Input() underlined: boolean = false;
}
